module.exports = __webpack_public_path__ + "static/media/me.c93de810.jpg";